import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Product from "@/components/Product";
import SizeGuide from "@/components/SizeGuide";
import ProductDetails from "@/components/ProductDetails";
import Reviews from "@/components/Reviews";
import { SHOTS } from "@/components/People";

export default function ShopPage() {
  const navigate = useNavigate();

  return (
    <motion.main
      data-testid="shop-page"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      className="bg-paper"
    >
      <section className="bg-black text-paper px-5 sm:px-10 pt-24 sm:pt-28 pb-8 sm:pb-10">
        <div className="mx-auto max-w-7xl">
          <button
            data-testid="shop-back-button"
            onClick={() => navigate("/")}
            className="relative z-10 font-sans text-paper/60 hover:text-acid text-xs font-bold tracking-[0.25em] transition-colors mb-6"
          >
            ← BACK TO THE CHAOS
          </button>
          <h1
            data-testid="shop-title"
            className="font-display text-[clamp(2.6rem,8vw,7rem)] leading-[0.85]"
          >
            GET THE <span className="text-acid">SHIRT.</span>
          </h1>
          <p className="font-sans text-paper/60 text-xs sm:text-sm font-semibold tracking-[0.3em] mt-4">
            SIZES · SIZE CHART · INSTRUCTIONS FOR USE — ALL IN ONE PLACE
          </p>
        </div>
      </section>

      <Product kicker="01 — THE PRODUCT" compact />
      <SizeGuide kicker="02 — SIZE GUIDE" />
      <ProductDetails kicker="03 — PRODUCT DETAILS" />

      <section data-testid="rebel-strip" className="bg-black text-paper py-14 sm:py-20 overflow-hidden">
        <div className="mx-auto max-w-7xl px-5 sm:px-10">
          <p className="font-sans text-turq text-xs font-semibold tracking-[0.35em] mb-4">WORN BY REBELS</p>
          <h3 className="font-display text-[clamp(1.8rem,5vw,3.5rem)] leading-[0.9]">
            THE TEE, OUT IN THE <span className="text-pink">WILD.</span>
          </h3>
        </div>
        <div className="mt-8 flex gap-4 sm:gap-6 overflow-x-auto no-scrollbar snap-x px-5 sm:px-10 pb-4" data-testid="rebel-strip-row">
          {SHOTS.map((s, i) => (
            <img
              loading="lazy"
              decoding="async"
              key={s.src}
              src={s.src}
              alt={s.alt}
              data-testid={`rebel-strip-${i + 1}`}
              className={`snap-center shrink-0 h-[34vh] sm:h-[42vh] w-auto object-cover border border-white/10 ${s.rot}`}
            />
          ))}
        </div>
      </section>

      <Reviews />
    </motion.main>
  );
}
